import firebase from 'firebase'
const config = {
    apiKey: "AIzaSyARTS5iHNC6Jibc1qib_s10nqRssRyE0R0",
    authDomain: "help-center-circadence.firebaseapp.com",
    databaseURL: "https://help-center-circadence.firebaseio.com",
    projectId: "help-center-circadence",
    storageBucket: "help-center-circadence.appspot.com",
    messagingSenderId: "533002309530",
    appId: "1:533002309530:web:ead56f473c8a604591b423",
    measurementId: "G-XH0DNNFJXZ"
};
firebase.initializeApp(config);
firebase.analytics();

export default firebase;


export const auth = firebase.auth();



 